export const isPreview = () => {
  const route = useRoute()
  return typeof route.fullPath === 'string' && route.fullPath.includes('preview')
}
